import { defineStore } from 'pinia';
import IPaymentRequiredData from '@/interfaces/iPaymentRequiredData';
import PaymentRequiredAction from '@/interfaces/paymentRequiredAction';
import router from '@/router';
import NoPaymentSessionDataFoundError from '@/entities/errors/noPaymentSessionDataFoundError';
import { Token } from '@cyber-range/cyber-range-api-authentication-client';
import PaymentProcessorFactory from '.././utils/paymentProcessing/paymentProcessorFactory';
import { useApiClientStore } from './apiClientStore';
import { useAuthenticationStore } from './authenticationStore';

interface IStoredSessionData
{
    userToken: string;
    data: IPaymentRequiredData
}

export const usePaymentStore = defineStore('paymentStore', {
    state: () => ({
        requiredPaymentData: {},
        processingPaymentMessage: '',
    }),
    actions: {
        restorePaymentRequiredData(vendibleId: string)
        {
            let data:  IStoredSessionData;
            try {
                data = JSON.parse(window.sessionStorage.getItem(vendibleId));
            } catch (error) {}

            let userToken: string;
            if (data)
            {
                this.requiredPaymentData[data.data.vendibleId] = data.data;
                userToken = data.userToken;
            }
            else
            {
                userToken = sessionStorage.getItem('token');
            }

            useAuthenticationStore().setToken(new Token(userToken));
        },
        paymentRequired(data: IPaymentRequiredData)
        {
            this.requiredPaymentData[data.vendibleId] = data;

            const userToken = useAuthenticationStore().token;
            window.sessionStorage.setItem(data.vendibleId, JSON.stringify({ data, userToken }));

            router.push(`/vendibles/${data.vendibleId}/pay`);
        },
        async purchaseVendible(vendibleId: string): Promise<void>
        {
            const vendibleApiClient = useApiClientStore().vendibleApiClient;
            const  { paymentUrl } = await vendibleApiClient.getPaymentUrl(vendibleId);

            if (window.self !== window.top)
            {
                const openedWindow = window.open(paymentUrl, undefined, 'popup=true');

                window.addEventListener('message', event => {
                    if (event.source !== openedWindow || event.data !== 'paymentProcessed')
                    {
                        return
                    }

                    router.push(`/vendibles/${vendibleId}/confirmed`);
                });
            }
            else
            {
                window.location.assign(paymentUrl);
            }
        },
        async processPaymentConfirmed(vendibleId: string)
        {
            if (window.opener)
            {
                window.opener.postMessage('paymentProcessed');
                window.close();
                return;
            }

            const paymentProcessor = await PaymentProcessorFactory.create(vendibleId);
            if (paymentProcessor.message)
            {
                this.processingPaymentMessage = paymentProcessor.message;
            }
            await paymentProcessor.process();
        }
    }
});
